import { useGetAppDetailsQuery } from '@app/services';
import { useParams } from 'react-router-dom';

export function useCurrentApp() {
    const { name } = useParams();

    const { data: app, isError, isFetching, isLoading, error } = useGetAppDetailsQuery(name as string);

    return { app, isError, isFetching, isLoading, error };
}
